import { render, staticRenderFns } from "./DocIcon.vue?vue&type=template&id=3b6773d0&scoped=true&"
import script from "./DocIcon.vue?vue&type=script&lang=js&"
export * from "./DocIcon.vue?vue&type=script&lang=js&"
import style0 from "./DocIcon.vue?vue&type=style&index=0&id=3b6773d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6773d0",
  null
  
)

export default component.exports